var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation"},[_c('v-container',[(_vm.layout == 'empty')?_c('Widget',{attrs:{"position":"MainMenu"}}):(_vm.layout == 'auth')?_c('Widget',{attrs:{"position":"menu_profile"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }